<template>
  <div class="api-doc-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1 class="page-title">商城服务</h1>
      <!-- <p class="page-subtitle">惠优选公共API接口文档与密钥管理</p> -->
      <p class="page-subtitle">惠优选公共API接口文档</p>
    </div>

    <!-- 商户密钥列表 -->
    <!-- <div class="section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="icon-key"></i>
          商户密钥列表
        </h2>
        <p class="section-desc">点击复制按钮可快速复制密钥到剪贴板</p>
      </div>

      <div class="table-container">
        <el-table
          :data="activeList"
          style="width: 100%"
          empty-text="暂无活动数据"
          class="secret-table"
          :header-cell-style="{ background: '#afb68d', color: '#fff', fontWeight: 'bold' }"
          stripe
        >
          <el-table-column prop="activeName" label="活动名称" min-width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="activity-name">{{ scope.row.activeName || '未命名活动' }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="secret_key"
            label="Secret Key"
            min-width="300"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="secret-key-cell">
                <span class="secret-text">{{ scope.row.secret_key || '暂无密钥' }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="copySecretKey(scope.row.secret_key)"
                :disabled="!scope.row.secret_key"
                class="copy-btn-table"
              >
                <i class="el-icon-copy-document"></i>
                复制
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>-->

    <!-- 开发文档 -->
    <div class="section">
      <div class="section-header">
        <h2 class="section-title">
          <i class="icon-doc"></i>
          开发文档
        </h2>
        <p class="section-desc">API接口使用说明与示例代码</p>
      </div>

      <div class="doc-card">
        <div class="doc-info">
          <h3 class="doc-title">惠优选公共API文档</h3>
          <div class="doc-link-container">
            <span class="doc-link">{{ link }}</span>
            <div class="doc-actions">
              <button class="action-btn copy-link-btn" @click="copyLink(link)">
                <i class="icon-copy"></i>
                复制链接
              </button>
              <button class="action-btn open-link-btn" @click="openLink(link)">
                <i class="icon-external"></i>
                新窗口打开
              </button>
            </div>
          </div>
          <!-- <div class="doc-password">
            <span class="password-label">访问密码：</span>
            <span class="password-value">Hyx123...</span>
            <button class="copy-password-btn" @click="copyPassword">
              <i class="icon-copy"></i>
            </button>
          </div>-->
        </div>

        <div class="doc-info">
          <h3 class="doc-title">京东公共API文档</h3>
          <div class="doc-link-container">
            <span class="doc-link">{{ jdLink }}</span>
            <div class="doc-actions">
              <button class="action-btn copy-link-btn" @click="copyLink(jdLink)">
                <i class="icon-copy"></i>
                复制链接
              </button>
              <button class="action-btn open-link-btn" @click="openLink(jdLink)">
                <i class="icon-external"></i>
                新窗口打开
              </button>
            </div>
          </div>
          <div class="doc-password">
            <span class="password-label">访问密码：</span>
            <span class="password-value">Hyx123...</span>
            <button class="copy-password-btn" @click="copyPassword">
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  async created() {},
  data() {
    return {
      activeList: [], // activeName，secret_key
      link: "https://docs.apipost.net/docs/44f8c6e54ce0000?locale=zh-cn",
      jdLink: "https://docs.apipost.net/docs/48ca512a187a000?locale=zh-cn"
    };
  },
  methods: {
    // 复制Secret Key
    async copySecretKey(secretKey) {
      if (!secretKey) {
        this.$message.warning("该活动暂无密钥");
        return;
      }

      try {
        await this.copyToClipboard(secretKey);
        this.$message.success("密钥已复制到剪贴板");
      } catch (error) {
        console.error("复制失败:", error);
        this.$message.error("复制失败，请手动复制");
      }
    },

    // 复制文档链接
    async copyLink(link) {
      try {
        await this.copyToClipboard(link);
        this.$message.success("文档链接已复制到剪贴板");
      } catch (error) {
        console.error("复制失败:", error);
        this.$message.error("复制失败，请手动复制");
      }
    },

    // 复制密码
    async copyPassword() {
      try {
        await this.copyToClipboard("Hyx123...");
        this.$message.success("密码已复制到剪贴板");
      } catch (error) {
        console.error("复制失败:", error);
        this.$message.error("复制失败，请手动复制");
      }
    },

    // 新窗口打开链接
    openLink(link) {
      window.open(link, "_blank");
    },

    // 复制到剪贴板的通用方法
    async copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        // 使用现代 Clipboard API
        await navigator.clipboard.writeText(text);
      } else {
        // 降级方案：使用 document.execCommand
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          document.execCommand("copy");
        } finally {
          document.body.removeChild(textArea);
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
/* 主题色定义 */
@primary-color: #0053e2;
@primary-light: #3380e8;
@primary-dark: #003bb0;
@text-primary: #2c3e50;
@text-secondary: #6c757d;
@background-light: #f8f9fa;
@border-color: #e9ecef;
@shadow-light: 0 2px 4px rgba(0, 0, 0, 0.1);
@shadow-medium: 0 4px 12px rgba(0, 0, 0, 0.15);

.api-doc-container {
  padding: 24px;
  background-color: #fff;
  max-height: 80vh;
  overflow-y: scroll;
}

/* 页面标题区域 */
.page-header {
  text-align: center;
  padding: 32px 0;
  background: linear-gradient(135deg, @primary-color, @primary-light);
  border-radius: 12px;
  color: white;
}

.page-title {
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 8px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  color: white;
}

.page-subtitle {
  font-size: 16px;
  margin: 0;
  opacity: 0.9;
}

/* 区块样式 */
.section {
  margin: 32px 0;
  background: white;
  border-radius: 12px;
  box-shadow: @shadow-light;
  overflow: hidden;
}

.section-header {
  padding: 24px 32px 16px;
  background: @background-light;
  border-bottom: 1px solid @border-color;
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  color: @text-primary;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-desc {
  color: @text-secondary;
  margin: 0;
  font-size: 14px;
}

/* 图标样式 */
.icon-key::before {
  content: "🔑";
}
.icon-doc::before {
  content: "📚";
}
.icon-copy::before {
  content: "📋";
}
.icon-external::before {
  content: "🔗";
}
.icon-empty::before {
  content: "📭";
}

/* 表格容器样式 */
.table-container {
  padding: 24px 32px;
}

.secret-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: @shadow-light;
}

/* 表格内容样式 */
.activity-name {
  font-weight: 500;
  color: @text-primary;
}

.secret-key-cell {
  display: flex;
  align-items: center;
}

.secret-text {
  font-family: "Monaco", "Consolas", monospace;
  font-size: 13px;
  color: @text-primary;
  word-break: break-all;
  line-height: 1.4;
}

/* 表格复制按钮样式 */
.copy-btn-table {
  background-color: @primary-color !important;
  border-color: @primary-color !important;
  font-size: 12px;
  padding: 5px 10px;
}

.copy-btn-table:hover {
  background-color: @primary-dark !important;
  border-color: @primary-dark !important;
}

.copy-btn-table:disabled {
  background-color: #ccc !important;
  border-color: #ccc !important;
  cursor: not-allowed;
}

/* Element UI 表格样式覆盖 */
.secret-table .el-table__row:hover > td {
  background-color: @primary-light !important;
  background-color: rgba(175, 182, 141, 0.1) !important;
}

.secret-table .el-table__stripe {
  background-color: #fafafa;
}

.secret-table .el-table th {
  background-color: @primary-color !important;
}

.secret-table .el-table__empty-text {
  color: @text-secondary;
  font-size: 16px;
}

/* 文档卡片样式 */
.doc-card {
  padding: 32px;
}

.doc-info {
  margin: 20px 0;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 12px;
  padding: 24px;
  border: 2px solid @border-color;
}

.doc-title {
  font-size: 18px;
  font-weight: 600;
  color: @text-primary;
  margin: 0 0 20px 0;
}

.doc-link-container {
  margin-bottom: 20px;
}

.doc-link {
  display: block;
  background: white;
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid @border-color;
  font-family: "Monaco", "Consolas", monospace;
  font-size: 14px;
  color: @primary-color;
  margin-bottom: 12px;
  word-break: break-all;
}

.doc-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.action-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
}

.copy-link-btn {
  background: @primary-color;
  color: white;
}

.copy-link-btn:hover {
  background: @primary-dark;
  transform: translateY(-1px);
}

.open-link-btn {
  background: #007bff;
  color: white;
}

.open-link-btn:hover {
  background: #0056b3;
  transform: translateY(-1px);
}

.doc-password {
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid @border-color;
}

.password-label {
  font-weight: 600;
  color: @text-primary;
}

.password-value {
  font-family: "Monaco", "Consolas", monospace;
  font-size: 16px;
  font-weight: bold;
  color: #dc3545;
  letter-spacing: 2px;
}

.copy-password-btn {
  background: @primary-color;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.3s ease;
}

.copy-password-btn:hover {
  background: @primary-dark;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .api-doc-container {
    padding: 16px;
  }

  .page-header {
    padding: 24px 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .section-header {
    padding: 16px 20px 12px;
  }

  .table-container {
    padding: 16px 20px;
  }

  .doc-card {
    padding: 20px;
  }

  .doc-actions {
    flex-direction: column;
  }

  .action-btn {
    justify-content: center;
  }

  /* 移动端表格样式调整 */
  .secret-table .el-table__body-wrapper {
    overflow-x: auto;
  }

  .copy-btn-table {
    font-size: 11px;
    padding: 4px 8px;
  }
}
</style>